import { render, staticRenderFns } from "./global-frame.vue?vue&type=template&id=60068f78&"
import script from "./global-frame.vue?vue&type=script&lang=js&"
export * from "./global-frame.vue?vue&type=script&lang=js&"
import style0 from "./global-frame.vue?vue&type=style&index=0&id=60068f78&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports